export default {
      id: "icon-star-usage",
      viewBox: "0 0 18.289 17.07",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }